import Box from "@mui/material/Box";
import React, { FC, ReactNode } from "react";

export interface IModalFooterProps {
  children: ReactNode;
  hasShadow?: boolean;
}

const ModalFooter: FC<IModalFooterProps> = ({ children, hasShadow }) => {
  return (
    <Box
      sx={{
        px: 6,
        pt: hasShadow ? 6 : 5,
        pb: 6,
        boxShadow: hasShadow
          ? " 0px -10px 20px rgba(35, 33, 42, 0.05)"
          : "none",
      }}
    >
      {children}
    </Box>
  );
};

export default ModalFooter;
